import http from "../../services/httpService";

const apiEndpoint = '/v3';

export const getActiveLocales = async () => {
  const url  = `${apiEndpoint}/locales`
  const result = await http.get(url);
  return result;
}
